import React, { useEffect, useState } from 'react';
import { FieldProps, FieldValidation } from '@rjsf/core';
import { FormControl } from '@material-ui/core';
import { useGetAPI } from '../../Utils/useGetAPI';
import {
  BackstageIdentityApi,
  microsoftAuthApiRef,
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
  useApi,
} from '@backstage/core-plugin-api';

import axios from 'axios';
import { Select } from '@backstage/core-components';
import Alert from '@mui/material/Alert';

type repoNameType = {
  repoName: string;
  newRepoUrl: string;
};

type optionsArrayType = [
  {
    label: string;
    value: string;
  },
];

export const ExistingRepoDropdown = ({
  onChange,
  formContext,
}: FieldProps<string>) => {
  const [formState, setFormState] = useState<repoNameType>({
    repoName: '',
    newRepoUrl: '',
  });

  const [options, setOptions] = useState<optionsArrayType>([
    { label: 'Select an Owner', value: 'loading' },
  ]);
  const [error, setError] = useState<boolean>(false);

  const url: string = useGetAPI();
  const identityAPI: OAuthApi &
    OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi = useApi(microsoftAuthApiRef);

  const repoUrl: string = formContext.formData.repoUrl || '';

  const repoUrlPrefix: string = `${repoUrl.slice(0, 13)}?`;

  const params: URLSearchParams = new URLSearchParams(repoUrl.slice(14));

  const owner: string | null = params.get('owner');
  const org: string | null = params.get('organization');

  onChange(formState);

  const getData = async () => {
    const token = await identityAPI.getIdToken();

    await axios
      .get(`${url}/v1/api/devops/repos/${owner}`, {
        headers: {
          Authorization: `Basic ${token}`,
        },
      })
      .then(res => {
        const repoArray =
          res !== undefined && res.data.value !== null ? res.data.value : [];

        const scrubRepoArray = Array.from(repoArray)
          .sort()
          .map(repo => {
            return {
              label: repo?.name.toLowerCase(),
              value: repo?.name,
            };
          });

        scrubRepoArray.unshift({
          label: 'Select a Project',
          value: '',
        });

        setOptions(scrubRepoArray);
        setError(false);
      })
      .catch(e => {
        setError(true);
      });
  };

  useEffect(() => {
    if (owner !== null && owner.length > 1 && org === 'ablcode') {
      setOptions([{ label: 'Loading', value: 'loading' }]);
      getData();
    }
    // can't think of a simpler and better way to handle the api call when the user selects a different owner. Think should keep this as is.
    // eslint-disable-next-line
  }, [owner]);

  function sortArr(value: any) {
    return function sorterFunction(a: any, b: any) {
      if (a[value] > b[value]) {
        return 1;
      } else if (a[value] < b[value]) {
        return -1;
      }
      return 0;
    };
  }

  return (
    <FormControl>
      {error === false ? (
        <Select
          native
          label="Repositories Available"
          onChange={selected => {
            setFormState({
              repoName: selected.toString(),
              newRepoUrl: `${repoUrlPrefix}owner=${owner}&repo=${selected.toString()}&organization=${org}`,
            });
          }}
          items={options.sort(sortArr('label'))}
          selected={formState.repoName}
        />
      ) : (
        <Alert severity="error">
          There was an issue with your request. Please wait a few minutes and
          try again.{' '}
        </Alert>
      )}
    </FormControl>
  );
};

export const existingRepoDropdownValidation = (
  value: repoNameType,
  validation: FieldValidation,
) => {
  if (value.repoName === undefined || value.repoName.length < 1) {
    validation.addError('Please select a repo from the dropdown.');
  }
};
